"use client";

import { useLoadingFeatureFlagEnabled } from "@/app/_analytics/posthog-client";
import { Skeleton } from "@ui/components/core/Skeleton";
import dynamic from "next/dynamic";
import { useTranslations } from "next-intl";

import type { TTSProps } from "./TTS";

import EditorCards from "./components/EditorCards";
import { FEATURE_FLAGS } from "@/app/_analytics/feature-flags";

const TTSWithClientFlag = dynamic(() => import("./TTS"));

export const TTSWrapper = (props: TTSProps & { isCardsExperiment?: boolean }) => {
  const { enabled, isPending } = useLoadingFeatureFlagEnabled(FEATURE_FLAGS.ENABLE_LANGUES_DEMO_SIMPLE_CARDS, {
    variantKey: "test",
  });
  const t = useTranslations("ClientKeys.TTS");
  if (!props.isCardsExperiment) {
    return <TTSWithClientFlag {...props} />;
  }

  if (isPending) {
    return <Skeleton className='h-[600px] w-full' />;
  }

  if (enabled) {
    return (
      <div className='flex flex-col gap-32'>
        <EditorCards
          demoPrompts={{ samplePrompts: props.samplePrompts, useCasePrompts: props.initialPrompts }}
          voices={props.voices ?? []}
        />
        <span className='f-ui-03 text-lighter'>{t("widget.create_your_own_speech")}</span>
        <TTSWithClientFlag {...props} forceEditor hideSamples size='md' />
      </div>
    );
  }

  return <TTSWithClientFlag {...props} />;
};
